import { render, staticRenderFns } from "./BnIrszam.vue?vue&type=template&id=eb9e4960&scoped=true&"
import script from "./BnIrszam.vue?vue&type=script&lang=js&"
export * from "./BnIrszam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb9e4960",
  null
  
)

export default component.exports